import { makeStyles } from '@material-ui/core';

const drawerWidth = 75;

const styles = makeStyles((_theme) => ({
  drawer: {
    flexShrink: 1,
  },
  drawerPaper: {
    width: drawerWidth,
    justifyContent: 'flex-start',
    alignItems: 'center',
    paddingTop: 10,
    overflowX: 'hidden',
  },
  item: {
    display: 'flex',
    flexDirection: 'column',
  },
  container: {
    justifyContent: 'center',
    display: 'flex',
    flex: 1,
    paddingRight: 15,
    paddingLeft: 15,
  },

  imageIcon: {
    height: '100%',
  },

  listStyle: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    justifyContent: 'center',
  },
  avatar: {
    marginBottom: 20,
    cursor: 'pointer',
  },
  manualButton: {
    textTransform: 'none',
    padding: '6px 8px',
    justifyContent: 'flex-start',
    '& .MuiButton-startIcon': {
      marginRight: 8,
    },
  },
  subHeaderStyle: {
    textDecorationLine: 'underline',
    textTransform: 'none',
    padding: 0,
  },
  userPopover: {
    padding: 10,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 10,
    '& span': {
      fontWeight: 'bold',
    },
  },
  menuItemTextSmall: {
    fontSize: '0.7rem',
  },
  noPermissionsNotice: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 24,
    minWidth: 0,
  },
}));

export default styles;
